import { render } from "./ReturnProductDetailDisplay.vue?vue&type=template&id=34b38a32&scoped=true&ts=true"
import script from "./ReturnProductDetailDisplay.vue?vue&type=script&lang=ts"
export * from "./ReturnProductDetailDisplay.vue?vue&type=script&lang=ts"

import "./ReturnProductDetailDisplay.vue?vue&type=style&index=0&id=34b38a32&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34b38a32"]])

export default __exports__